<div class="chat-body">
  <div id="chat-container">
    <div id="search-container">
      <input type="text" placeholder="Search" />
    </div>
    <div id="conversation-list">
      <div class="conversation">
        <img src="../../../assets/images/profiles/kim.jpeg" alt="profile1" />
        <div class="title-text">Loren Ipsum</div>
        <div class="created-date">Apr 16</div>
        <div class="conversation-message">
          Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nisi
          nesciunt ab harum perferendis. Suscipit?
        </div>
      </div>
      <div class="conversation">
        <img src="../../../assets/images/profiles/sarah.jpeg" alt="profile1" />
        <div class="title-text">Loren Ipsum</div>
        <div class="created-date">Apr 16</div>
        <div class="conversation-message">
          Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nisi
          nesciunt ab harum perferendis. Suscipit?
        </div>
      </div>
      <div class="conversation">
        <img src="../../../assets/images/profiles/stacey.jpeg" alt="profile1" />
        <div class="title-text">Loren Ipsum</div>
        <div class="created-date">Apr 16</div>
        <div class="conversation-message">
          Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nisi
          nesciunt ab harum perferendis. Suscipit?
        </div>
      </div>
      <div class="conversation">
        <img src="../../../assets/images/profiles/kim.jpeg" alt="profile1" />
        <div class="title-text">Loren Ipsum</div>
        <div class="created-date">Apr 16</div>
        <div class="conversation-message">
          Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nisi
          nesciunt ab harum perferendis. Suscipit?
        </div>
      </div>
      <div class="conversation">
        <img src="../../../assets/images/profiles/sarah.jpeg" alt="profile1" />
        <div class="title-text">Loren Ipsum</div>
        <div class="created-date">Apr 16</div>
        <div class="conversation-message">
          Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nisi
          nesciunt ab harum perferendis. Suscipit?
        </div>
      </div>
      <div class="conversation">
        <img src="../../../assets/images/profiles/stacey.jpeg" alt="profile1" />
        <div class="title-text">Loren Ipsum</div>
        <div class="created-date">Apr 16</div>
        <div class="conversation-message">
          Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nisi
          nesciunt ab harum perferendis. Suscipit?
        </div>
      </div>
    </div>
    <div id="new-message-container">
      <a href="#">+</a>
    </div>

    <div id="chat-title">
      <span>I am a Robot!</span>
      <img
        src="../../../assets/images/icons/trash-logo.svg"
        alt="Delete Conversation"
      />
    </div>
    <div id="chat-message-list">
      <div class="message-row you-message">
        <div class="message-content">
          <div class="message-text">Ok then</div>
          <div class="message-time">Apr 16</div>
        </div>
      </div>

      <div class="message-row other-message">
        <div class="message-content">
          <img src="../../../assets/images/profiles/sarah.jpeg" alt="sarah" />
          <div class="message-text">
            Lorem ipsum dolor sit amet. Lorem ipsum dolor, sit amet consectetur
            adipisicing elit. Eveniet, quas.
          </div>
          <div class="message-time">Apr 16</div>
        </div>
      </div>
      <div class="message-row other-message">
        <div class="message-content">
          <img src="../../../assets/images/profiles/sarah.jpeg" alt="sarah" />
          <div class="message-text">
            Lorem ipsum dolor sit amet. Lorem ipsum dolor, sit amet consectetur
            adipisicing elit. Eveniet, quas.
          </div>
          <div class="message-time">Apr 16</div>
        </div>
      </div>
      <div class="message-row you-message">
        <div class="message-content">
          <div class="message-text">Lorem, ipsum dolor.</div>
          <div class="message-time">Apr 16</div>
        </div>
      </div>
    </div>
    <div id="chat-form">
      <img
        src="../../../assets/images/icons/attachment-logo.svg"
        alt="Add attachment"
      />
      <input type="text" placeholder="type a message" />
    </div>
  </div>
</div>
